module.exports = __webpack_public_path__ + "static/media/school_detail_banner_bottom.3de5415a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school_detail_banner_bottom.png
// module id = 915
// module chunks = 0